import React from "react";
import styles from "./Background.module.css";

const Background = () => {
  return (
    <div className={styles.background}>
      <div className={styles.img}></div>
    </div>
  );
};

export default Background;
